import Cookies from 'js-cookie';

import { axiosGetRequest, axiosPostRequest } from '../../../utils/axiosRequests';
import { useCallback, useEffect, useState } from 'react';

export const useFetchSubscribersWithOrder = ({ deliveryDate, subscriberType }) => {
  const token = Cookies.get('jwt');

  const duplicateOrdersFn = useCallback(
    async (subscriberIds, duplicateAt) => {
      return axiosPostRequest('/admin/subscribers/duplicateLastOrder', token, {
        subscriberIds,
        deliveryDate,
        duplicateAt,
      });
    },
    [token, deliveryDate]
  );

  const [result, setResult] = useState({
    loading: true,
    subscribers: [],
    duplicateOrdersFn,
  });

  useEffect(() => {
    const fetchData = async () => {
      let url = `/admin/subscribers/getSubscribersWithOrder?subscriberType=${subscriberType}`;
      if (deliveryDate) url += `&deliveryDate=${deliveryDate}`;
      const response = await axiosGetRequest(url, token);

      if (response.status === 200) {
        setResult((prev) => ({
          ...prev,
          loading: false,
          subscribers: response.data.data.subscribers,
          duplicateOrdersFn,
        }));
      }
    };

    fetchData();
  }, [token, deliveryDate, subscriberType, duplicateOrdersFn]);

  return result;
};
